export default __webpack_public_path__ + "static/media/icon_up_arrow_pink.96eac041.svg";